var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-layout',[(_vm.error && _vm.error.code === 403)?_c('NotAuthorised'):(_vm.error && _vm.error.code === 404)?_c('NotFound'):_c('div',{staticClass:"container-nzidoo mt-4"},[_c('ProductHeader',{attrs:{"product":_vm.currentProduct,"loading":_vm.loader}}),_c('BoostPlansMenu',{attrs:{"product":_vm.currentProduct}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }